import React, { memo, useMemo, useState } from 'react';
import AccountInfo from './AccountInfo';
import useAuth from '../../../hooks/useAuth';
import { ORIGIN } from '../../../constants';
import { Button, DepositDemoModal } from '@vt/vt-ui';
import { depositDemoApi } from '../../../api/account';
import { Notification } from '../../../utilities/alert';

const typeServer = { api: 'Live' };
const accountTypeName = { Standard: 'Standard', StandardBonus: 'Standard+', Cent: 'Cent' };

const getOriginUrl = (countryId, originUrl) => {
  if (countryId === 9) {
    return 'https://www.id-iux.com';
  } else if (countryId === 10) {
    return 'https://www.iuxvn.com';
  } else {
    return ORIGIN[originUrl];
  }
};

const TopMenuAccountInfo = memo(() => {
  const { activeAccount, metatrader, getFirebaseCustom, user } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const account = useMemo(
    () =>
      metatrader?.reduce((a, b) => {
        return {
          ...a,
          [b.id]: b
        };
      }, {}),
    [metatrader]
  );

  // console.log('openModal', openModal)

  if (!account) return;
  return (
    <div className="flex items-center">
      <div className="border-r border-r-[#585858] px-[14px]">
        <div className="text-[#E5E5E5] flex items-center justify-start font-bold text-sm">
          <span className="mr-2">Account:</span>
          <span>{account[activeAccount]?.account_number}</span>
        </div>
        <div className="font-bold text-sm whitespace-pre">
          <span
            className={`capitalize ${account[activeAccount]?.api_server === 'demo' ? 'text-[#FE9F01]' : 'text-[#0FEF9E]'
              }`}>
            {typeServer[account[activeAccount]?.api_server]
              ? typeServer[account[activeAccount]?.api_server]
              : account[activeAccount]?.api_server}
          </span>
          <span className="capitalize text-sm text-[#9F9F9F]">{` - ${accountTypeName[account[activeAccount]?.account_type] ??
            account[activeAccount]?.account_type
            }`}</span>
        </div>
      </div>
      <AccountInfo />
      <Button
        rel="noreferrer"
        variant="outline-primary"
        className='p-3 hover:!text-[#151515]'
        onClick={() => {
          if (account[activeAccount]?.api_server === 'demo') {
            setOpenModal(true);
          } else {
            getFirebaseCustom().then((token) => {
              window.open(
                `${getOriginUrl(
                  user?.data?.personal_detail?.country_id,
                  window.location.origin
                )}/en/login?token=${token}&account=${account[activeAccount]?.account_number}`
              );
            });
          }
        }}
      >
        Deposit
      </Button>
      <DepositDemoModal
        accountId={localStorage.getItem('customiduat') ?? account[activeAccount]?.id}
        isOpen={openModal}
        depositdemo={async ({ account_id, balance }) => {
          try {
            return await depositDemoApi({ id: account_id, balance });
          } catch (err) {
            Notification({
              message: 'An error has occurred.',
              title: 'Error',
              type: 'danger'
            });
            throw err;
          }
        }}
        headers={{
          language: 'en',
          'x-country': 1,
          'x-platform': 'web'
        }}
        lang="en"
        onClose={() => {
          setOpenModal(false);
        }}
        onDepositDemoSuccess={({ balance, account_id }) => {
          Notification({
            message: `The amount of ${balance.toLocaleString()} USD has been credited to your account.`,
            title: 'Success',
            type: 'success'
          });
          setOpenModal(false);
        }}
      />
    </div>
  );
});

TopMenuAccountInfo.displayName = 'TopMenuAccountInfo';
export default TopMenuAccountInfo;
